import { Form } from 'antd'
import { VISIBILITY_OPTIONS } from 'domains/IngredientsTree/constants'
import { getFormattedENumber } from 'domains/Ingredients/helpers'
import { useEffect } from 'react'

/**
 * Custom hook to initialize the advanced form for managing ingredient data.
 *
 * @param {Object} initialData - The initial data for the form.
 * @returns {Object} - An object containing the form instance and state for disabling fields.
 */
const useInitializeIngredientAdvancedForm = (initialData, productIds = []) => {
  const [form] = Form.useForm()
  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      const ingredient = { ...initialData }

      const formValues = {
        _id: ingredient?._id || null,
        name: ingredient?.name || ingredient?.translations?.EN || null,
        nameNO: ingredient?.translations?.NO || null,
        nameEN: ingredient?.translations?.EN || null,
        nameUK: ingredient?.translations?.UK || null,
        eNumber: getFormattedENumber(ingredient?.eNumber) || null,
        description: ingredient?.description || null,
        synonyms: ingredient?.synonyms || [],
        hiddenSynonyms: ingredient?.hiddenSynonyms || [],
        productsIds: [],
        isIngredient: ingredient?.isIngredient || false,
        isVisibleInRecipes: ingredient?.isVisibleInRecipes || false,
        isDeclared: ingredient?.isDeclared || false,
        visibility: ingredient?.visibility || VISIBILITY_OPTIONS.fullyVisible
      }

      // Set the form values
      form.setFieldsValue({ ingredient: formValues })
    } else {
      // Reset form when initialData is null or empty (e.g., when creating new node)
      form.resetFields()
    }
  }, [initialData, form])

  useEffect(() => {
    form.setFieldsValue({
      ingredient: {
        productsIds: Array.isArray(productIds) ? productIds : []
      }
    })
  }, [productIds, form])

  return { form }
}

export default useInitializeIngredientAdvancedForm
